import { render, staticRenderFns } from "./main_records.vue?vue&type=template&id=1de61ef7&scoped=true"
import script from "./main_records.vue?vue&type=script&lang=js"
export * from "./main_records.vue?vue&type=script&lang=js"
import style0 from "./main_records.vue?vue&type=style&index=0&id=1de61ef7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de61ef7",
  null
  
)

export default component.exports